import { TObject } from 'utils/types';

import { REPORT_STATE } from './constants';
import { IReport } from './types';

export const normalizeReport = (data: TObject): IReport => {
  return {
    completed: (data?.completed as string) || '',
    created: (data?.created as string) || '',
    fileName: (data?.fileName as string) || '',
    id: (data?.id as string) || '',
    size: (data?.fileSize as number) || 0,
    status: data?.status as REPORT_STATE,
  };
};
